import { TakenSubdomainTypeEnum } from '@zaoblako/shared/modules/saas/enums/taken-subdomain-type.enum';
import { TakenSubdomainTypeEnumI18n } from '@zaoblako/shared/modules/saas/i18n/taken-subdomain-type-enum.i18n';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SaasDtoKeysEnum } from '@zaoblako/shared/modules/saas/enums/saas-dto-keys.enum';

import * as yup from 'yup';

/** Subdomain per type response body - DTO signature */
export type SubdomainPerTypeInterface = Partial<Record<TakenSubdomainTypeEnum, string>>;

/** Subdomain per type response body - DTO schema */
export const SubdomainPerTypeDto = SerdeDtoClass.create<SubdomainPerTypeInterface>(
  SaasDtoKeysEnum.SUBDOMAIN_PER_TYPE_DTO,
  Object.fromEntries(
    Object
      .values(TakenSubdomainTypeEnum)
      .map(type => [
        type,
        {
          optional: true,
          label: (context): string => TakenSubdomainTypeEnumI18n[context?.data?.locale || I18nLocalesEnum.RU_RU][type],
          serializer: yup.string(),
        },
      ]),
  ),
);
